const API_ROOT = process.env.API_ROOT;
const NODE_ENV = process.env.NODE_ENV;
const VERSION = process.env.VERSION;

export { API_ROOT, NODE_ENV, VERSION };
